import { HttpResponse } from '@angular/common/http';
import { Reflection } from './reflection';
import { ReflectionDto } from './reflection.dto';

export class PaginatedDto {
    readonly payload: Reflection[];
    readonly total: number;

    constructor(response: HttpResponse<ReflectionDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new Reflection(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
